import moment from "moment-timezone";
export const getTimeData = (date, timezone) => {
  return moment(new Date(date))
    .tz(timezone || "Asia/Kuala_Lumpur")
    .format("YYYY-MM-DDTHH:mm:ss");
};
export const getUTCData = (date) => {
  return moment.utc(new Date(date)).utc().format("YYYY-MM-DDTHH:mm:ss");
};
export const getMyZone = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

export const convertTo12Hour = (time24) => {
  if (!time24) return "";
  const [h, m] = time24.split(":");
  const hour = +h; // shorthand for parseInt
  return `${hour === 0 ? 12 : hour > 12 ? hour - 12 : hour}:${m} ${
    hour < 12 ? "AM" : "PM"
  }`;
};
